module.exports = __webpack_public_path__ + "static/forecast/fresh-snow/waist-c236951b6136409756a4730fbdcbae99.svg";